import { Box, CloudinaryImage, Text } from '@stitch-fix/mode-react';
import { ShopCategoryImage } from '../../types/definitions/vendor/graphql-schema.d';
import styles from './styles.module.scss';
type PageHeaderProps = {
  title?: string;
  subTitle?: string | null;
  image?: ShopCategoryImage | null;
  handle?: string | null;
};
const PageHeader = ({
  handle,
  image,
  subTitle,
  title
}: PageHeaderProps) =>
// Title is required to render the header
!title ? null : <Box className={styles.pageHeader}>
      {image && <Box className={styles.thumbnail}>
          <CloudinaryImage alt={image.altText} baseUrl={image.baseUrl} mediaPath={image.mediaPath} sizes={{
      sm: 62,
      md: 78,
      lg: 102
    }} />
        </Box>}
      <Text setting="title-medium">{title}</Text>
      {subTitle && <Text as="h3" mt={0.75} setting="subtitle-small">
          {subTitle}
        </Text>}
      {handle && <Text setting="body-small" color="gray-35">
          {handle}
        </Text>}
    </Box>;
export default PageHeader;